import React from 'react';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { HomeScreen } from './components/HomeScreen';
import { SearchScreen } from './components/SearchScreen';

const AppContent: React.FC = () => {
  const { user, isLoading, logout } = useAuth();
  
  // Determine which screen to show based on user state
  const showSearchScreen = user && !isLoading;

  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ 
            width: '50px', 
            height: '50px', 
            border: '4px solid #f3f3f3',
            borderTop: '4px solid #E65E33',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 20px'
          }}></div>
          <p style={{ color: '#6B7280', fontSize: '1.1rem' }}>Loading...</p>
        </div>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  if (showSearchScreen) {
    return <SearchScreen onLogout={logout} />;
  }

  return <HomeScreen onLoginSuccess={() => {}} />;
};

const App: React.FC = () => {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
};

export default App;// Keyboard fix deployed Thu Sep 18 12:07:41 PDT 2025
// Updated Git config for Vercel deployment Thu Sep 18 12:12:10 PDT 2025
